<script>
    import REST from '../RESTClass.js';
    import { watchResize } from "svelte-watch-resize";
    import { setMoverVisibility } from '../Utils';

    import Card from '../Components/Card/Card.svelte';
    import Mover from '../Components/Mover/Mover.svelte';

    let moviesData;
    let moverVisible = true;
    let settings;

    const API = new REST();
    API.getMovies()
        .then(data => moviesData = data);
    API.getSettings()
        .then(data => settings = data);
</script>

<section class="movies">
    <h2 class="padded">
        Relacje filmowe
        {#if settings}
            <a class="movies-channel" href={settings.channel} target="_blank"><i class="fab fa-youtube"></i></a>
        {/if}
    </h2>
    <div use:watchResize={node => moverVisible = setMoverVisibility(node)} class="latest-movies padded">
        {#if moviesData}
            {#each moviesData as entry}
                <Card 
                    type="youtube"
                    content={{
                        movieID: entry.id
                    }}
                    props={{
                        spaced: true
                    }}
                />
            {/each}
        {/if}
    </div>
    <Mover 
        props={{
            range: 300,
            visible: moverVisible
        }}
    />
</section>

<style type="text/scss">
    h2 {
        color: #c2ae8d;
        font-family: 'Rufina', serif;
        font-size: 18px;
        margin: 1.2rem 0;
        text-transform: uppercase;
    }

    .movies {
        &-channel {
            color: #c2ae8d;
            text-decoration: none;
        }

        .latest-movies {
            display: flex;
            flex-direction: row-reverse;
            overflow-x: scroll;
            -ms-overflow-style: none;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }

    
</style>
